import Image from 'next/image';
import { useState, useEffect } from 'react';
import cn from 'clsx';
import { client } from '../../utils/http';

export default function TwitterImage(props) {
  const [isLoading, setLoading] = useState(false);
  const [src, setSrc] = useState(props.src.replace('_normal', ''));
  const userID = props.userID;
  useEffect(() => setSrc(props.src.replace('_normal', '')), [props.src]); // update the `src` value when the `prop.src` value changes

  return (
    <Image
      width={props.width}
      height={props.height}
      src={src}
      alt={props.alt} // assuming `props.alt` is the user's Twitter username
      className={cn(
        props.className,
        'object-cover duration-700 ease-in-out',
        isLoading
          ? 'scale-110 blur-2xl grayscale' // to create the blur loading effect
          : 'scale-100 blur-0 grayscale-0',
      )}
      onLoadingComplete={async () => {
        if (src) {
          if (src.startsWith('https://abs.twimg.com/')) {
            // try to update images that are the default Twitter profile pic
            await updateTwitterDP(props.alt, setSrc, userID);
          }
          setLoading(false);
        }
      }}
      onError={async () => {
        if (src) {
          if (
            src.startsWith('https://abs.twimg.com/') ||
            src.startsWith('https://pbs.twimg.com/')
          ) {
            await updateTwitterDP(props.alt, setSrc, userID);
          }
        }
      }}
    />
  );
}

export async function updateTwitterDP(username, setSrc, userID) {
  try {
    const { data } = await client.get(
      `/api/twitter/update-dp?username=${username}&userID=${userID}`,
    );
    setSrc(data.src);
  } catch (err) {
    console.error(err);
  }
}
